import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {SportsContent} from '../sports-content.js';

import {inPlayPageFactory} from './inplay-page.factory';

import PALETTE_SCHEMA from './inplay-page.palette-schema.yaml';

class InPlayPageFeature extends AbstractVisualFeature {
    get name() {
        return 'InPlay Page';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return inPlayPageFactory(PALETTE);
    }
}

new InPlayPageFeature(SportsContent);
